import { useRef } from 'react';

import { FEN_STARTING_POSITION } from '@libs/chess/constants';
import { movesToFen, MovesToFenResult } from '@libs/chess/movesToFen';
import { IPgnMove } from '@libs/chess/pgn';

export function usePlaySequenceFen(
  initialFen = FEN_STARTING_POSITION,
  playSequence?: IPgnMove[],
): MovesToFenResult {
  const selectionCacheRef = useRef<Record<string, MovesToFenResult>>({});

  const fenRef = useRef(initialFen);
  if (fenRef.current !== initialFen) {
    fenRef.current = initialFen;
    selectionCacheRef.current = {};
  }

  return mapSelectionMetadata(initialFen, playSequence, selectionCacheRef.current);
}

function mapSelectionMetadata(
  initialFen: string,
  playSequence: IPgnMove[] | undefined,
  cache: Record<string, MovesToFenResult>,
): MovesToFenResult {
  const id = playSequence?.map((m) => m.san).join(' ') ?? '';

  if (!cache[id]) {
    cache[id] = movesToFen(initialFen, playSequence);
  }

  return cache[id];
}
